import { css } from '@emotion/react';

export const Default64px = css`
  font-family: Poppins, sans-serif;
  font-size: 64px;
  font-weight: 600;
  line-height: 76px;
  letter-spacing: -0.02em;
`;

export const Default48px = css`
  font-family: Poppins, sans-serif;
  font-size: 48px;
  font-weight: 600;
  line-height: 56px;
  letter-spacing: -0.02em;
`;

export const Default40px = css`
  font-family: Poppins, sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.02em;
`;

export const Default32px = css`
  font-family: Poppins, sans-serif;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  letter-spacing: -0.015em;
`;

export const Default24px = css`
  font-family: Poppins, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.015em;
`;

export const Default18px = css`
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: -0.015em;
`;

export const Default16px = css`
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.015em;
`;

export const Default14px = css`
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.015em;
`;

export const Default12px = css`
  font-family: Inter, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.015em;
`;

export const Default10px = css`
  font-family: Inter, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.01em;
`;
